import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import { icons } from "../../constants";

const SeraloginOnlineHeader = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="custom-header">
        <button
          className="back-button"
          onClick={() => navigate("/")}
        >
          <img
            className="btn-icon"
            style={{ width: "auto" }}
            src={icons.so_goback}
            alt="icon"
          />
        </button>
        <img
          src="/images/logo_seranest_online.png"
          alt="Logo"
          className="logo"
        />
      </div>
    </>
  );
};

export default SeraloginOnlineHeader;
